import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Stack, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { brmRightStyles } from "../../right/companySetup/brmRightStyle";
import { customScrollbar } from "components/screen/phase-3/riskAdmin/RiskTabs";
import { useNumberFormatter } from "customHooks/useNumberFormatter";

const Label = ({ children }) => (
  <Typography
    fontSize="medium"
    sx={{
      color: "#9A9A9A",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.1%",
    }}
  >
    {children}
  </Typography>
);

const ReadonlyField = ({ label, value }) => (
  <Box sx={{ flex: 1 }}>
    <Label>{label}</Label>
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      value={value || "N/A"}
      InputProps={{ readOnly: true }}
      sx={{ mt: 0.5 }}
    />
  </Box>
);

export const TagBox = ({ value, active = true }) =>
  value ? (
    <Box
      sx={{
        borderRadius: "8px",
        fontWeight: 400,
        py: "8px",
        px: "12px",
        lineHeight: "18px",
        background: active ? "#F0F5FF" : "#F6F6F6",
        color: active ? "#0A2E65" : "#737373",
      }}
    >
      {value}
    </Box>
  ) : null;

const SupplierDetails = () => {
  const classes = brmRightStyles();
  const { formatNumberWithCommas } =
      useNumberFormatter();

  const {
    supplier_name = "",
    linkage = "",
    sector = "",
    industry = "",
    poc = "",
    contact_no = "",
    purchase_value = "",
    currency = "",
    logo = {},
  } = useSelector((s) => s.riskAdminReducer.listings["viewSupplier"]?.item) ||
  {};
  const linkageTypes = ["Corporate", "SBU", "Unit"];
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <Box sx={{ flex: 1, overflow: "auto", p: 2, ...customScrollbar }}>
        <Typography
          variant="h3"
          sx={{ color: "#0F0F0F", fontWeight: 600, mb: 2 }}
        >
          Supplier Details
        </Typography>

        <Stack spacing={3} mt={2}>
          <ReadonlyField label="Company Name" value={supplier_name} />

          <Box>
            <Label>Linkage</Label>
            <Stack direction="row" spacing={1} mt={1}>
              {linkageTypes.map((type) => (
                <TagBox
                  key={type}
                  value={type === "SBU" ? "Strategic Business Unit" : type}
                  active={linkage === type}
                />
              ))}
            </Stack>
          </Box>

          <Stack direction="row" spacing={2}>
            <ReadonlyField label="POC" value={poc} />
            <ReadonlyField label="Contact Number" value={contact_no} />
            <ReadonlyField label="Purchase Value" value={formatNumberWithCommas(purchase_value)} />
            <ReadonlyField label="Currency" value={currency} />
          </Stack>

          <Box>
            <Label>Supplier Logo</Label>
            <Stack direction="row" alignItems="center" spacing={1} mt={1} poi>
              <Box className={classes.logoSelecter}>
                <AddCircleOutlineIcon
                  name="addLogoIcon"
                  fontSize="large"
                  className={classes.addIcon}
                />
              </Box>
              {logo?.url && (
                <Box className={classes.logoSelecter}>
                  <img
                    src={logo?.url}
                    alt="Supplier Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </Box>
              )}
            </Stack>
          </Box>

          {/* Sector & Industry */}
          <Box>
            <Label>Sector & Industry</Label>
            <Stack direction="row" spacing={1} mt={1}>
              <TagBox value={sector} />
              <TagBox value={industry} />
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default SupplierDetails;
